const budget = {
    needs: ['Transport', 'Groceries', 'Utilities', 'Health'],
    wants: ['Entertainment', 'Shopping', 'Restaurants', 'Clothes', 'Gifts', 'Travel', 'Alcohol', 'Subscribtions'],
    savings: ['Savings', 'Investments']
}

export default budget;

